import { types } from 'mobx-state-tree';

const ShowIf = types.model('ShowIf', {
  key: types.string,
  value: types.maybe(types.string),
  values: types.optional(types.array(types.string), []),
});

const Question = types.model('Question', {
  id: types.identifier,
  statement: types.string,
  type: types.enumeration(['RatingScale', 'Text', 'MultipleChoice', 'MultiSelect', 'SensitivityScale']),
  scale: types.maybeNull(types.number),
  keyword: types.maybeNull(types.enumeration(['Agree', 'Confident', 'Likely'])),
  options: types.optional(types.array(types.string), []),
  sensitivityOptions: types.optional(types.array(types.string), []),
  anchors: types.optional(types.array(types.string), []),
  optional: types.optional(types.boolean, false),
  key: types.maybeNull(types.string),
  showIf: types.maybeNull(ShowIf),
  description: types.maybeNull(types.string),
  hint: types.maybeNull(types.string),
});

const Survey = types
  .model('Survey', {
    id: types.identifier,
    questions: types.optional(types.array(Question), []),
    questionsCount: types.optional(types.integer, 0),
    // When set, the survey page renders the learner's assigned-project header (number, paper
    // title, authors, DOI) above the questions. Used by the pre/post workshop instruments so the
    // matched items are answered under the same stimulus at both time points.
    showAssignedProject: types.optional(types.boolean, false),
  })
  .actions(self => ({})) // eslint-disable-line no-unused-vars
  .views(self => ({})); // eslint-disable-line no-unused-vars

export { Survey };
